export default __webpack_public_path__ + "static/media/rps.97cde1bc.png";